<template>
    <router-view></router-view>
</template>

<script>
    export default {
        metaInfo: {
            titleTemplate: '%s - AHM Sparepart Activities',
        }
    }
</script>